@file:OptIn(ExperimentalMaterial3Api::class)

package us.laantech.laanmanage.feature.employee

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.lifecycle.ViewModel
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.lifecycle.viewmodel.initializer
import androidx.lifecycle.viewmodel.viewModelFactory
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.http.isSuccess
import io.ktor.http.parameters
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import us.laantech.common.dto.EmployeeDTO
import us.laantech.common.dto.PayPeriod
import us.laantech.common.dto.company.ParentCompany
import us.laantech.common.ui.DataTableView
import us.laantech.laanmanage.feature.scope.ParentCompanyScope
import us.laantech.common.ui.DropdownMenu
import us.laantech.common.api.KtorClient

data class EmployeeManagementUiState(
    val managers: List<EmployeeDTO> = emptyList(),
    val employees: List<EmployeeDTO> = emptyList(),
    val showCreateEmployeeModal: Boolean = false,

    // Create employee modal fields
    val employeeName: TextFieldState = TextFieldState(""),
    val employeePayRate: TextFieldState = TextFieldState(""),
    val selectedPayPeriod: PayPeriod? = null,
    val employeePhoneNumber: TextFieldState = TextFieldState(""),
    val employeeEmail: TextFieldState = TextFieldState("")
)

@Composable
fun EmployeeManagementView(
    viewModel: EmployeeManagementViewModel = viewModel(
        factory = viewModelFactory {
            initializer { EmployeeManagementViewModel() }
        }
    )
) {
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    ParentCompanyScope(requireBranch = false) { parentCompany, _ ->
        LaunchedEffect(parentCompany) { viewModel.loadEmployees(parentCompany) }

        Button(onClick = { viewModel.toggleCreateEmployeeModal() }) {
            Text("Create Employee")
        }


        DataTableView(
            Modifier,
            rows = uiState.managers,
        ) {
            column("Name") {
                Text("TODO")
            }
        }

        DataTableView(
            Modifier,
            rows = uiState.employees,
        ) {
            column("Name") {
                Text("TODO")
            }
        }


        if (uiState.showCreateEmployeeModal) {
            AlertDialog(
                { viewModel.toggleCreateEmployeeModal() },
                confirmButton = {
                    Button(onClick = {
                        viewModel.toggleCreateEmployeeModal()
                        viewModel.createEmployee()
                    }) {
                        Text("Create")
                    }
                },
                title = {
                    Text("Create Employee")
                },
                text = {
                    CreateEmployeeForm(viewModel)
                }
            )
        }
    }
}

@Composable
fun CreateEmployeeForm(viewModel: EmployeeManagementViewModel) {

    val uiState by viewModel.uiState.collectAsStateWithLifecycle()

    Column {
        TextField(uiState.employeeName, Modifier.fillMaxWidth(), label = { Text("Name") })

        Row(verticalAlignment = Alignment.CenterVertically) {
            TextField(uiState.employeePayRate, Modifier.weight(1f), label = { Text("Pay Rate") })
            DropdownMenu(
                label = "Pay Period",
                items = PayPeriod.entries,
                selectedItem = uiState.selectedPayPeriod,
                itemLabel = { it.name },
                noneLabel = "Select Pay Period",
                onItemSelected = { viewModel.updatePayPeriod(it) },
                modifier = Modifier.weight(1f)
            )
        }

        // is manager
        var selectedIndex by remember { mutableIntStateOf(0) }
        val options = listOf("Employee", "Manager")
        SingleChoiceSegmentedButtonRow {
            options.forEachIndexed { index, label ->
                SegmentedButton(
                    shape = SegmentedButtonDefaults.itemShape(
                        index = index,
                        count = options.size
                    ),
                    onClick = { selectedIndex = index },
                    selected = index == selectedIndex,
                    label = { Text(label) }
                )
            }
        }

        // if manager then allow them to select the branch or access all stores
        Text("TODO, select branches")

    }
}


class EmployeeManagementViewModel: ViewModel() {

    private val _uiState = MutableStateFlow(EmployeeManagementUiState())
    val uiState = _uiState.asStateFlow()
    val ktClient = KtorClient.instance.client

    suspend fun loadEmployees(parentCompany: ParentCompany) {
        val response = ktClient.get("/backoffice/employees/list") {
            parameter(ParentCompany::uuid.name, parentCompany.uuid)
        }
        if (response.status.isSuccess()) {
            _uiState.update { it.copy(employees = response.body()) }
        }
    }

    fun toggleCreateEmployeeModal() {
        _uiState.update { it.copy(showCreateEmployeeModal = !it.showCreateEmployeeModal) }
    }

    fun createEmployee() {

    }

    fun updatePayPeriod(payPeriod: PayPeriod?) {
        _uiState.update { it.copy(selectedPayPeriod = payPeriod) }
    }

}